
import { commonfunc } from '~/mixin/common'
import { swiperBannerClick } from '~/mixin/swiperBannerClick'
import { pushBannerGtmData } from '~/utils/gtm'

import BannerContent from '~/components/common/BannerContent.vue'

export default {
  name: 'SwiperCmp',
  components: {
    BannerContent
  },
  mixins: [commonfunc, swiperBannerClick],
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          auto: false,
          loop: false,
          navigation: false,
          pagination: false
        }
      }
    },
    bnnrList: { // 배너 데이터
      type: [Array, Object],
      default () { return [] }
    },
    swiperType: {
      type: String,
      default: ''
    },
    swiperClass: {
      type: String,
      default: ''
    },
    exhCmptmtId: {
      type: String,
      default: ''
    },
    topSubBanner: {
      type: Boolean,
      default: null
    },
    activeOffset: {
      type: Number,
      default: null
    },
    activeOffsetClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      swiperOpt: {
        slidesPerView: 1,
        loop: false,
        lazy: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
          // nextEl: '#button-next-relacionados.swiper-button-next',
          // prevEl: '#button-prev-relacionados.swiper-button-prev'
        },
        pagination: {
          el: `.swiper-pagination-${this._uid}`,
          clickable: true,
          type: 'fraction', // 버튼 디자인 bullets" / "fraction"
          renderBullet (index, className) {
            return '<button type="button" aria-label="' + (index + 1) + '번 슬라이드로 이동하기" class="' + className + '"><span class="hiddenText">' + (index + 1) + '</span></button>'
          },
          renderFraction (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' + '<span class="divide">/</span>' + '<span class="' + totalClass + '"></span>'
          }
        },
        freeMode: false,
        slidesPerColumn: 1,
        grid: {
          rows: 1
        }
      },
      autoStatus: true
    }
  },
  computed: {
    topBannerSingle () {
      return this.topSubBanner && this.bnnrList.length === 1
    }
  },
  created () {
    // 자동롤링
    if (this.options.auto === false) {
      this.swiperOpt.autoplay = this.options.auto
      this.autoStatus = false
    } else if (typeof this.options.auto === 'number') {
      this.swiperOpt.autoplay.delay = this.options.auto
      this.autoStatus = false
    }

    // 네비게이션
    if (this.options.navigation === false) {
      this.swiperOpt.navigation = false
    }

    // 무한루프
    if (this.options.loop === true) {
      this.swiperOpt.loop = this.options.loop
    }

    // 인디케이터
    if (this.options.pagination === 'fraction') {
      this.swiperOpt.pagination.type = this.options.pagination
    }

    // freeMode
    if (this.options.freeMode === true) {
      this.swiperOpt.freeMode = this.options.freeMode
    }

    // slidesPerView
    if (this.options.slidesPerView !== undefined) {
      this.swiperOpt.slidesPerView = this.options.slidesPerView
    }

    // slidesPerColumn
    if (typeof this.options.slidesPerColumn === 'number') {
      this.swiperOpt.slidesPerColumn = this.options.slidesPerColumn
    }

    // slidesPerGroup
    if (typeof this.options.slidesPerGroup === 'number') {
      this.swiperOpt.slidesPerGroup = this.options.slidesPerGroup
    }

    // grid
    if (typeof this.options.grid === 'number') {
      this.swiperOpt.grid.rows = this.options.grid
    }

    // spaceBetween
    if (typeof this.options.spaceBetween === 'number') {
      this.swiperOpt.spaceBetween = this.options.spaceBetween
    }

    // direction
    if (this.options.direction === 'vertical') {
      this.swiperOpt.direction = this.options.direction
    }

    // console.log('swiperOptswiperOptswiperOpt', this.swiperOpt)
  },
  mounted () {
    if (this.bnnrList.length === 1) {
      this.swiperDestroy()
      return // swiper destroy 후 GTM 등록 불필요
    }
    if (this.swiperType === 'oneline') {
      this.$refs.swiperEl.swiper.allowTouchMove = false
    }
    // GTM 트래킹: loop 복제 슬라이드 포함 (mixin addSwiperBannerGtm 사용)
    this.addSwiperBannerGtm(
      this.$refs.swiperEl?.swiper,
      () => this.bnnrList,
      (item, realIndex) => this.trackBannerGtm(item, realIndex)
    )
    this.bindActiveOffsetClass()
  },
  methods: {
    // GTM 트래킹만 담당 (navigation은 :to/:href 속성이 처리)
    trackBannerGtm (item, realIndex) {
      if (this.$route.path === '/ds') {
        pushBannerGtmData({
          fileNm: item.pcomIconOrglFileNm,
          bannerText: item.banrRplcTextNm,
          index: realIndex + 1,
          location: 'PC홈메인_띠 배너_' + this.exhCmptmtId
        }, true)
      } else {
        pushBannerGtmData({ fileNm: item.pcomIconOrglFileNm }, false)
      }
    },
    stopSwiper () {
      console.log('stop', this.$refs.swiperEl)
      this.$refs.swiperEl.swiper.autoplay.stop()
      this.autoStatus = false
    },
    playSwiper () {
      console.log('play')
      this.$refs.swiperEl.swiper.autoplay.start()
      this.autoStatus = true
    },
    swiperDestroy () {
      this.$refs.swiperEl.swiper.destroy()
    },
    bindActiveOffsetClass () {
      const swiper = this.$refs.swiperEl?.swiper
      if (!swiper || this.activeOffset === null || !this.activeOffsetClass || !this.bnnrList.length) { return }
      this.$nextTick(() => {
        this.updateActiveOffsetClass()
        swiper.on('slideChange', this.updateActiveOffsetClass)
        swiper.on('transitionEnd', this.updateActiveOffsetClass)
        swiper.on('loopFix', this.updateActiveOffsetClass)
      })
    },
    updateActiveOffsetClass () {
      const swiper = this.$refs.swiperEl?.swiper
      if (!swiper || this.activeOffset === null || !this.activeOffsetClass || !this.bnnrList.length) { return }
      const slideList = Array.from(swiper.slides || [])
      const targetIndex = this.swiperOpt.loop
        ? ((swiper.activeIndex + this.activeOffset) % slideList.length + slideList.length) % slideList.length
        : ((swiper.realIndex + this.activeOffset) % this.bnnrList.length + this.bnnrList.length) % this.bnnrList.length

      slideList.forEach((slide, index) => {
        const isTarget = index === targetIndex
        slide.classList.toggle(this.activeOffsetClass, isTarget)
      })
    },
    goPrev () {
      const swiper = this.$refs.swiperEl?.swiper
      if (!swiper) { return }
      if (swiper.animating) {
        swiper.animating = false
      }
      swiper.slidePrev()
    },
    goNext () {
      const swiper = this.$refs.swiperEl?.swiper
      if (!swiper) { return }
      if (swiper.animating) {
        swiper.animating = false
      }
      swiper.slideNext()
    },
  }
}
